import { FAN_REASONS } from '../weekly/v2/constants';
import type { FanAngleKey } from '../../services/fanSuggestionsService';

/**
 * The angle vocabulary for "L'idée du jour". Kept out of the .tsx so it stays
 * importable from plain-TS tests and from the recipes screen without dragging
 * in React Native.
 *
 * `balance` is excluded: it ranks against the diet mix of a planned week, which
 * the recipes home screen does not have.
 */
export const IDEA_ANGLES: FanAngleKey[] = ['fast', 'fridge', 'new', 'fav'];

/** Angle key → accent colour, shared with the planner's replace-fan. */
export const ACCENT_BY_ANGLE: Record<string, string> = Object.fromEntries(
  FAN_REASONS.map((r) => [r.key, r.accent]),
);

/** i18n key for an angle's label, e.g. "Utilise votre frigo". */
export const angleLabelKey = (angle: FanAngleKey): string =>
  `recipes.ideaOfDay.angles.${angle}`;
